// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_math from "rescript/lib/es6/js_math.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function formatDurationJs(seconds) {
  if (seconds < 60) {
    return String(seconds) + "s";
  }
  var minutes = seconds / 60 | 0;
  var remainder = seconds % 60;
  return String(minutes) + "m " + String(remainder) + "s";
}

function updateElapsedJs(panelEl) {
  Belt_Array.forEach(Array.from(panelEl.querySelectorAll("[data-task-id]")), (function (taskEl) {
          var status = DomEl$GameDataCore.data(taskEl, "status");
          var startedAtRaw = DomEl$GameDataCore.data(taskEl, "started-at");
          var elapsedEl = taskEl.querySelector("[data-elapsed]");
          if (elapsedEl == null) {
            return ;
          }
          if (!(status === "processing" && startedAtRaw !== "")) {
            return ;
          }
          var startedAt = Date.parse(startedAtRaw);
          if (!Number.isFinite(startedAt)) {
            return ;
          }
          var seconds = Math.max(0, Js_math.floor_int((Date.now() - startedAt) / 1000));
          elapsedEl.textContent = formatDurationJs(seconds);
        }));
}

function clearTimer(self) {
  var timer = self.timer;
  if (!(timer == null)) {
    clearInterval(timer);
    return ;
  }
  
}

function mounted() {
  var self = this ;
  var element = self.el;
  var timer = setInterval((function () {
          updateElapsedJs(element);
        }), 1000);
  self.timer = timer;
  updateElapsedJs(element);
}

function updated() {
  var self = this ;
  updateElapsedJs(self.el);
}

function destroyed() {
  var self = this ;
  clearTimer(self);
}

var processingNotificationPanel = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  formatDurationJs ,
  updateElapsedJs ,
  clearTimer ,
  mounted ,
  updated ,
  destroyed ,
  processingNotificationPanel ,
}
/* mounted Not a pure module */
